// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"1a27d068ceff72436da0","655":"b74fb31c1a33a18573f7"}[chunkId] + ".js";
};